<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/cXEBGb/tc-custom/9781466856455.jpg?1726444326141" alt="This image is the cover for the book Terminator 3"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Terminator 3
      </h1>
      <p class="bookDescription body article font2">
        <b>An amnesiac computer programmer holds the key to humanity’s salvation in this apocalyptic adventure inspired by the hit film.</b><br/><br/>Despite the heroic efforts of John Connor and Kate Webster, and the ultimate sacrifice of a T-850 terminator, Skynet became operational and mobilized its machine forces in all-out war against its prime enemy: mankind. More than twenty years later the war continues, fought by human resistance forces led by John and Kate, and by people in secret enclaves around the world. Raiding machine facilities, using small guerrilla forces to sabotage and destroy Skynet forces, the resistance is holding its own<i> . . .</i> but it’s not enough. The self-aware AI that controls the robot terminators, the hunter-killers, and the rest of what used to be America’s arsenal is too smart, too quick, too flexible to be defeated.<br/><br/>Or perhaps the answer to human victory lies elsewhere. Before Judgment Day, Danny Avila was a programmer on the project that became Skynet. In the months leading up to Judgment Day he began to have nightmares involving Terminators destroying the world. Then, two days before the holocaust, he disappeared. Found years later by John and Kate, completely amnesiac about events of his life prior to Judgment Day, he became a useful member of the resistance, with an uncanny ability to predict Skynet tactics.<br/><br/>Now he is having Terminator dreams again, dreams of the days when he was on the Terminator design team<i> . . .</i> of the days when the world was on the path to destruction. Could there be some kind of psychic link between the Danny of today and the Danny of nearly thirty years ago? Might this one desperately stressed man living in two eras be the time machine the resistance needs to undo the devastation of Judgment Day? A daring and dangerous experiment may prove the salvation of mankind’s future<i> . . .</i><br/><br/><b>Praise for <i>Terminator 3: Terminator Dreams</i></b><br/><br/>“Adolescents of all ages will have fun with Allston’s rock-’em sock-’em riff on the characters and settings of<i> . . .</i><i>Terminator 3: Rise of the Machines</i>.<i> . . .</i> Arnold’s adventure fans, rejoice; this is the stuff that role-playing dreams are made of.” —<i>Publishers Weekly</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Aaron Allston
      </h2>
      
      <p class="authorDescription body article"><P><B>Aaron Allston</B> is the author of a number of science fiction and fantasy novels, including the <I>Doc Sidhe</I> books, The Star Wars(TM) New Jedi Order novels<I> Rebel Dream</I> and <I>Rebel Stand</I>, among a number of novels, original and tie-in. An award-winning game designer as well as SF writer, he lives near Austin, Texas.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      A Tom Doherty Associates Book
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?72335885